import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { BluetoothSerial } from '@awesome-cordova-plugins/bluetooth-serial';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonLoading, IonTitle, IonToast } from "@ionic/react";
import { arrowBack } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import "./BluetoothSPP.css";

type Props = {
    closeAction: Function;
    closeActionSimple: Function;
};

const BluetoothSPP: React.FC<Props> = (props: Props) => {
    const [showLoading, setShowLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");
    const [bluetoothDevices, setBluetoothDevices] = useState<Array<{ name: string; address: string }>>([]);
    const [isScanning, setIsScanning] = useState(false);

    const scanDevices = async () => {
        try {
            setIsScanning(true);
            setShowLoading(true);
            setBluetoothDevices([]); // Limpa a lista ao iniciar a busca

            // Verifica se o Bluetooth está habilitado
            const isEnabled = await BluetoothSerial.isEnabled();

            if (!isEnabled) {
                setTextToast("Bluetooth está desabilitado. Habilitando...");
                setShowToast(true);
                await BluetoothSerial.enable();
            }

            console.log("Buscando dispositivos Bluetooth pareados...");

            // Lista dispositivos pareados
            const devices = await BluetoothSerial.list();
            console.log('Dispositivos Bluetooth encontrados:', devices);

            setBluetoothDevices(devices.map((device: any) => ({
                name: device.name,
                address: device.address
            })));

            if (devices.length === 0) {
                setTextToast("Nenhum dispositivo Bluetooth pareado encontrado. Pareie a impressora nas configurações do Android.");
                setShowToast(true);
            }
            // else {
            //     setTextToast(`${devices.length} dispositivo(s) encontrado(s)`);
            //     setShowToast(true);
            // }

            setIsScanning(false);
            setShowLoading(false);
        } catch (error) {
            console.error('Erro ao buscar dispositivos Bluetooth:', error);
            setTextToast("Erro ao buscar dispositivos Bluetooth.");
            setShowToast(true);
            setIsScanning(false);
            setShowLoading(false);
        }
    };

    useEffect(() => {
        scanDevices();
    }, []);

    const connectToDevice = async (address: string, name: string) => {
        // Não precisa mais conectar - apenas retorna os dados da impressora selecionada
        // A conexão será gerenciada automaticamente pelo PrintQueueContext
        console.log("Impressora SPP selecionada:", name, address);
        props.closeAction(address, name);
    };

    return (
        <>
            <IonHeader className="ion-no-border">
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonIcon
                            slot="icon-only"
                            icon={arrowBack}
                            onClick={() => {
                                props.closeActionSimple();
                            }}
                        />
                    </IonButtons>
                    <IonTitle>Bluetooth SPP (Android)</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen={false}>
                <IonLoading isOpen={showLoading} message="Carregando..." />
                <IonToast isOpen={showToast} message={textToast} duration={3000} />

                {bluetoothDevices.length > 0 && (
                    <div style={{ padding: '16px' }}>
                        <h3>Dispositivos Pareados:</h3>
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {bluetoothDevices.map((device, index) => (
                                <div key={index} style={{ marginBottom: '12px', borderBottom: '1px solid #ddd', paddingBottom: '12px' }}>
                                    <li>
                                        <strong>{device.name}</strong> <br />
                                        <span style={{ fontSize: '0.9em', color: '#666' }}>{device.address}</span>
                                    </li>
                                    <IonButton
                                        onClick={() => connectToDevice(device.address, device.name)}
                                        style={{ marginTop: '8px' }}
                                    >
                                        Selecionar
                                    </IonButton>
                                </div>
                            ))}
                        </ul>
                    </div>
                )}

                {bluetoothDevices.length === 0 && !isScanning && (
                    <div style={{ padding: '16px', textAlign: 'center' }}>
                        <p>Nenhum dispositivo encontrado.</p>
                    </div>
                )}
            </IonContent>

            <IonFooter className="ion-no-border">
                <IonToolbar>
                    <IonButton
                        onClick={() => scanDevices()}
                        expand="block"
                        type="submit"
                        disabled={isScanning}
                    >
                        {isScanning ? 'Buscando...' : 'Buscar Dispositivos'}
                    </IonButton>
                </IonToolbar>
            </IonFooter>
        </>
    );
};

export default BluetoothSPP;
